import * as React from 'react';
import * as ReactDOM from 'react-dom';

it('has a set project', () => {
	const project = process.env.REACT_APP_PROJECT;
	if(!project) throw("Project is not set");
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/multi-step-form.test.tsx